import { useState, useEffect, useRef } from 'react';
import { FaSearchPlus, FaSearchMinus, FaPlusSquare, FaMinusSquare } from 'react-icons/fa';
import ModelCore from './ModelCore';

function ModelViewer({ SD_pdfPropts, modelArr }) {
  const { state, action } = SD_pdfPropts;
  const [model, setModel] = useState(null);
  const [modelInd, setModelInd] = useState(null);
  const modelCoreRef = useRef(null);

  useEffect(() => {
    updateModelInd(0);
  }, [modelArr, state?.pages?.curr]);

  const setActiveLink = (link) => {
    action({ type: 'chng-active-link', data: link });
  };

  const updateModel = (modelInd) => {
    if (modelArr && modelInd >= 0 && modelInd < modelArr.length) {
      setModel(modelArr[modelInd]);
      return;
    }
    setModel(null);
  };

  const updateModelInd = (newInd) => {
    if (newInd < 0 || (modelArr.length && newInd >= modelArr.length)) {
      return;
    }
    setModelInd(newInd);
    updateModel(newInd);
  };

  // Zoom-in handler: reduces the camera orbit radius by a small amount.
  const handleZoomIn = () => {
    if (
      modelCoreRef.current &&
      modelCoreRef.current.tagName === 'MODEL-VIEWER'
    ) {
      const viewer = modelCoreRef.current;
      // Get the current camera orbit attribute or default to a baseline value.
      const cameraOrbitStr = viewer.getAttribute('camera-orbit') || '0deg 75deg 4.5m';
      const [theta, phi, radiusStr] = cameraOrbitStr.split(' ');
      let radius = parseFloat(radiusStr);
      // Reduce the radius to zoom in (with a minimum limit of 1m).
      radius = Math.max(radius - 0.5, 1);
      const newOrbit = `${theta} ${phi} ${radius}m`;
      viewer.setAttribute('camera-orbit', newOrbit);
      viewer.jumpCameraToGoal();
    }
  };

  // Zoom-out handler: increases the camera orbit radius by a small amount.
  const handleZoomOut = () => {
    if (
      modelCoreRef.current &&
      modelCoreRef.current.tagName === 'MODEL-VIEWER'
    ) {
      const viewer = modelCoreRef.current;
      const cameraOrbitStr = viewer.getAttribute('camera-orbit') || '0deg 75deg 4.5m';
      const [theta, phi, radiusStr] = cameraOrbitStr.split(' ');
      let radius = parseFloat(radiusStr);
      // Increase the radius to zoom out.
      radius = radius + 0.5;
      const newOrbit = `${theta} ${phi} ${radius}m`;
      viewer.setAttribute('camera-orbit', newOrbit);
      viewer.jumpCameraToGoal();
    }
  };

  if (!modelArr || modelArr?.length < 1) return 'No model found';

  return (
    <>
      {model ? (
        <div className="model-viewer-ctn">
          {/* Two icons for zoom in and zoom out */}
          <div className="model-zoom-controls">
          <FaPlusSquare size="2em" className="model-zoom" onClick={handleZoomIn} />
          <FaMinusSquare size="2em" className="model-zoom" onClick={handleZoomOut} />
          </div>
          <ModelCore model={model} ref={modelCoreRef} />
        </div>
      ) : null}
    </>
  );
}

export default ModelViewer;
